// ** React Imports
import React, { Fragment, ReactNode, useEffect } from 'react'

// ** Modules Imports
import dynamic from 'next/dynamic'
import { useStore } from 'effector-react'

// ** Source code Imports
import globalStore from 'src/state-manager/global'
import { useSettings } from 'src/@core/hooks'
import landingStore, { getLandingDetail } from 'src/state-manager/landing'
import tableColumnKeysConf from 'src/configs/db-columns-keys'
import tableEnumV2OptionsConf from 'src/configs/db-enum-v2-options'
import Spinner from 'src/@core/components/spinner'
import DefaultLayout from 'src/layouts/default-layout'
import newsStore, { getNewsList } from 'src/state-manager/news'

const keyValuesKeys = tableColumnKeysConf.keyValues
const keyValuesEnum = tableEnumV2OptionsConf.keyValues

const News = dynamic(() => import('src/views/pages/news-page'), {
  ssr: false
})

const NewsPage = () => {
  const settings = useSettings()

  const { language } = useStore(globalStore.locale)
  const { landingDetails } = useStore(landingStore.landing)
  const { data: newsData } = useStore(newsStore.news)

  useEffect(() => {
    getLandingDetail({
      query: {
        $or: [{ 'data.groupName': 'landing' }, { 'data.groupName': 'shared' }],
        $and: [
          {
            [`data.${keyValuesKeys.language}`]:
              language === 'ru' ? keyValuesEnum.language.ru : keyValuesEnum.language.en
          }
        ]
      }
    })

    getNewsList({
      query: { ['data.showToLanding']: true }
    })
  }, [language])

  const isLoading = landingDetails.loading

  return (
    <Fragment>
      {isLoading && <Spinner settings={settings} />}
      <DefaultLayout
        sx={{
          height: isLoading ? 0 : 'auto',
          visibility: isLoading ? 'hidden' : 'visible'
        }}
      >
        <News landingDetails={landingDetails.data} newsItems={newsData} />
      </DefaultLayout>
    </Fragment>
  )
}

NewsPage.getLayout = (page: ReactNode) => page

export default NewsPage
